import { NavMobile } from '../components/nav-mobile';
import { TheMarketFooter } from './footer';
import { TheMarketHeader } from './header';
import { ScrollTop } from '@/client/layouts/components/scroll-top';
import { PropsWithChildren } from 'react';

export type TheMarketLayoutProps = PropsWithChildren;

export const TheMarketLayout = ({ children }: TheMarketLayoutProps) => {
  return (
    <>
      {/* No settle rule banner: 5-minute settlement went back to the 1-minute kline on 10/8. */}
      <TheMarketHeader />
      <main className="w-full max-w-screen-3xl mx-auto">{children}</main>
      <NavMobile />
      <ScrollTop />
      <TheMarketFooter />
    </>
  );
};

export default TheMarketLayout;
